import { render, staticRenderFns } from "./ToggleFreeInputBehaviorEditor.vue?vue&type=template&id=4958ef3e&scoped=true&"
import script from "./ToggleFreeInputBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./ToggleFreeInputBehaviorEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4958ef3e",
  null
  
)

export default component.exports